module.exports = __webpack_public_path__ + "img/content3.355d1d1f.png";